import mixpanel from 'mixpanel-browser'

mixpanel.init('70c9e6f7ee71dd242a6be242930a0d0e')

export default mixpanel
